import React from 'react';
import { Box } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';

const ListItem: React.FunctionComponent<{
  label: string;
  value?: string | React.ReactNode;
  detail?: string;
}> = ({ label, value, detail }) => {
  return (
    <Box display={'flex'}>
      <Box minWidth={72} marginRight={2}>
        <CustomizedTypography variant="body2">{label}</CustomizedTypography>
      </Box>
      <Box>
        {!value && (
          <CustomizedTypography variant="body2" color={'textSecondary'}>
            업데이트 예정
          </CustomizedTypography>
        )}
        {value &&
          (typeof value === 'string' ? (
            <CustomizedTypography variant="body2" fontWeight="500">
              {value}
            </CustomizedTypography>
          ) : (
            value
          ))}
        {value && detail && (
          <CustomizedTypography variant="subtitle2" color="textSecondary">
            {detail}
          </CustomizedTypography>
        )}
      </Box>
    </Box>
  );
};

export default ListItem;
